import { Component, Input } from '@angular/core'
import { getIdentifierName } from 'src/app/_helpers/LocalStorage'
import { EditReponsible, GenericsEditable, ReportReponsible } from 'src/app/models/Reports'

@Component({
	selector: 'app-general-informations',
	templateUrl: './general-informations.component.html'
})
export class GeneralInformationComponent {
		@Input() public responsible: ReportReponsible = new ReportReponsible()
		@Input() public editResponsible: EditReponsible = new EditReponsible()
		@Input() public genericsEditable: GenericsEditable = new GenericsEditable()
		@Input() public createDate: string = ''
		@Input() public treeId: string = ''
		@Input() public disabled: boolean = true

		public identifierName = getIdentifierName()
}
